import { render, staticRenderFns } from "./V2DashboardWishlist.vue?vue&type=template&id=5fc9dcc4&scoped=true&"
import script from "./V2DashboardWishlist.vue?vue&type=script&lang=js&"
export * from "./V2DashboardWishlist.vue?vue&type=script&lang=js&"
import style0 from "./V2DashboardWishlist.vue?vue&type=style&index=0&id=5fc9dcc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc9dcc4",
  null
  
)

export default component.exports